module.exports = __webpack_public_path__ + "media/images/home/hero-dc0db4c8ac2ba919f9a878bf44461586.svg";